import React from 'react'
import cn from 'classnames'
import { withTranslation } from 'react-i18next'

import Quotes from 'app/components/SVGS/Quotes'
import RatingStar from 'app/components/SVGS/RatingStar'
import WistiaVideo from 'app/domains/common/WistiaVideo'
import { ratings } from 'app/constants/rates'

import './styles.scss'

const bc = 'activity-popover'

const ActivityPopover = ({ t, activity, isModal, onRequestClose }) => (
  <div className={cn(bc, { [`${bc}__modal`]: isModal })}>
    <div className={`${bc}__title`}>
      {isModal && (
        <span className={`${bc}__close-icon`} onClick={() => onRequestClose()}>
          &times;
        </span>
      )}
      <div>{t('Top Activity')}:</div>
      <div className={`${bc}__name`}>{activity.name}</div>
      <div className={`${bc}__protrack-name`}>{activity.proTrackName}</div>
    </div>
    <div className={`${bc}__rating`}>
      <span>{t('Rating')}:</span>
      <div>
        {ratings.map((rating, i) => (
          <div
            key={rating}
            className={cn(`${bc}__rated-star`, {
              [`${bc}__rated-star--active`]: i < activity.rating,
            })}
          >
            <RatingStar />
          </div>
        ))}
      </div>
    </div>

    <div className={`${bc}__quote-wrapper`}>
      <div className={`${bc}__quote`}>
        <Quotes />
        <p className={`${bc}__quote-text`}>{activity.proQuote}</p>
        <div className={`${bc}__quote-author`}>{`- ${activity.proQuoteAuthor}`}</div>
      </div>
      <div className={`${bc}__image`}>
        {activity.videoId ? (
          <WistiaVideo videoId={activity.videoId} videoThumbnail={activity.videoThumbnail} height={84} width={150} />
        ) : (
          <img src={activity.image} />
        )}
      </div>
    </div>
  </div>
)

export default withTranslation('user')(ActivityPopover)
